import { statsigClientProvider } from 'StatsigClientProvider';

export default function processForThirdParties(event, options = {}) {
    if (options.log_to_customerio) event.log_to_customerio = true;

    if (shouldPushToDataLayer(event.event_type)) window.dataLayer?.push({ event: event.event_type, ...event });
    if (shouldLogToStatsig(event.event_type)) logToStatsig(event);

    return event;
}

function logToStatsig(event) {
    const eventClone = { ...event };
    // statsig event metadata has character limits on strings
    // and objects so we need to remove potentially problematic properties
    // because if one of these properties is too long, the entire event metadata
    // will be dropped.
    // We don't often log events with very large payloads, but if we find our selves
    // needing to add more and more checks here this might be worth another look
    switch (eventClone.event_type) {
        case 'tutorbot:message_sent': {
            delete eventClone.message;
            delete eventClone.tutor_bot_message_payload;
            break;
        }
        default: {
            break;
        }
    }

    statsigClientProvider
        .waitForClient({ caller: 'logToStatsig' })
        .then(client => client.logEvent(eventClone.event_type, undefined, eventClone));
}

function shouldPushToDataLayer(event_type) {
    const eventPrefixesToSend = ['application-form'];
    const eventsToSend = [
        'user:logged_in_first_time',
        'cohort:conversion_goal',
        'lesson:clicked_launch',
        'lesson:finish',
        'cert_register',
    ];

    return eventsToSend.includes(event_type) || eventPrefixesToSend.some(prefix => event_type?.startsWith(prefix));
}

function shouldLogToStatsig(event_type) {
    const eventPrefixesToSend = ['application-form', 'student_network'];
    const eventsToSend = [
        'user:logged_in_first_time',
        'lesson:stream:start',
        'lesson:stream:complete',
        // below are added for ai advisor tooltip test
        'tutorbot:opened_ai_tutor',
        'tutorbot:message_sent',
        'tutorbot:dismissed_tooltip',
        'tutorbot:dismissed_audio_recap_lesson_tooltip',
        'lesson:complete',
        'lesson:finish',
        'lesson:start',
        'message_submitted_to_help_scout',
        'support_sidebar_opened',
        'tutorbot:opened_ai_tutor',
        'support_modal_closed',
        'tutorbot:message_sent_from_support_modal',
        'support_modal_swapped_to_contact_us_tab',
        // added for the recap last lesson audio mode test
        'tutorbot:opened_ai_tutor',
        'tutorbot:launched_text_chat',
        'tutorbot:opened_voice_agent_room',
        'tutorbot:started_voice_agent_conversation',
        'tutorbot:lesson_start_screen_launch_bot_clicked',
        'tutorbot:lesson_frame_launch_bot_clicked',
        'tutorbot:restart_voice_agent_conversation_clicked',
        'tutorbot:voice_session_will_end_soon',
        'tutorbot:voice_session_timed_out',
        // added for the Events and Student Spotlight v2 test
        'clicked_view_featured_events_in_network',
        'clicked_view_all_events_in_network',
        'clicked_view_event_in_network',
        'student-spotlight:carousel_scrolled',
        'student-spotlight:video_clicked',
    ];

    return eventsToSend.includes(event_type) || eventPrefixesToSend.some(prefix => event_type?.startsWith(prefix));
}
